import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { handleHeight } from "./defaults";
import { RowLayout } from "../../util/accordianStyles";
import useHandleHeightSelector from "./useHandleHeightSelector";

const HandleHeightAccordian: FC = () => {
  const { heading, handleClick, handleHeightChoice } =
    useHandleHeightSelector();

  return (
    <ReusableAccordian
      accordionName="handleHeight"
      heading={heading}
      secondaryHeading={`Select desired ${heading.toLowerCase()}`}
    >
      <RowLayout>
        {handleHeight.map((state) => (
          <div key={state.id} onClick={() => handleClick(state.label)}>
            <Choices
              wide={true}
              label={state.label}
              variant={
                state.label === handleHeightChoice ? "filled" : "outlined"
              }
              checkMark={state.label === handleHeightChoice}
            />
          </div>
        ))}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default memo(HandleHeightAccordian);
